export const generateMockBadges = (count: number, baseId: string, baseName: string, baseDescription: string, baseImageUrl: string, baseType: string) => {
  return Array.from({ length: count }, (_, index) => ({
    node: {
      id: `${baseId}-${index + 1}`,
      name: `${baseName} ${index + 1}`,
      description: `${baseDescription} ${index + 1}`,
      imageUrl: `${baseImageUrl}`,
      actionUrl: 'https://www.atlassian.com',
      type: baseType,
    },
  }));
};